const paths: Record<string, string> = {
  overview: '<path d="M4 13h6V4H4v9Zm0 7h6v-3H4v3Zm10 0h6v-9h-6v9Zm0-13h6V4h-6v3Z"/>',
  models: '<path d="m12 3 8 4.5-8 4.5-8-4.5L12 3Zm-8 9 8 4.5 8-4.5M4 16.5l8 4.5 8-4.5"/>',
  studio: '<path d="M8 3v3m8-3v3M5 8h14v11H5V8Zm3 4h8m-8 3h5"/>',
  evaluate: '<path d="m5 13 4 4L19 7M4 4h16v16H4V4Z"/>',
  endpoint: '<path d="M8 12h8M5 8l-3 4 3 4m14-8 3 4-3 4M9 5h6m-6 14h6"/>',
  requests: '<path d="M4 6h16M4 12h11M4 18h8m6-3 3 3-3 3"/>',
  usage: '<path d="M4 20V9m6 11V4m6 16v-7m5 7H3"/>',
  menu: '<path d="M4 7h16M4 12h16M4 17h16"/>',
  close: '<path d="m5 5 14 14M19 5 5 19"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m16.5 16.5 4 4"/>',
  chevron: '<path d="m9 6 6 6-6 6"/>',
  arrow: '<path d="M5 12h14m-5-5 5 5-5 5"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  run: '<path d="m8 5 11 7-11 7V5Z"/>',
  copy:
    '<rect x="8" y="8" width="11" height="11" rx="2"/>' +
    '<path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>',
  key: '<circle cx="8" cy="15" r="4"/><path d="m11 12 8-8m-3 3 3 3m-6 0 2 2"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  spark:
    '<path d="m12 3 1.4 4.6L18 9l-4.6 1.4L12 15l-1.4-4.6L6 9l4.6-1.4L12 3Z"/>' +
    '<path d="m18 15 .8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8L18 15Z"/>',
  image:
    '<rect x="4" y="5" width="16" height="14" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m5 17 4-4 3 3 3-4 4 5"/>',
  code: '<path d="m8 7-5 5 5 5m8-10 5 5-5 5m-2-13-4 16"/>',
  event: '<path d="M5 5h14v14H5V5Zm3 4h8m-8 3h8m-8 3h5"/>',
  filter: '<path d="M4 6h16M7 12h10m-7 6h4"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10h.01"/>',
  external: '<path d="M14 4h6v6m0-6-9 9M19 14v5H5V5h5"/>',
};

export function icon(name: keyof typeof paths, size = 18): string {
  return /* HTML */ `
    <svg
      aria-hidden="true"
      width="${size}"
      height="${size}"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      ${paths[name] ?? ''}
    </svg>
  `;
}
